import type { CatalogOutcome } from '../features/catalog/model';
import type { DiscoveryApi } from '../data/discovery';
import { commerceCatalogOutcomeDefinitions } from './catalogCapabilitiesCommerce';
import { dataCatalogOutcomeDefinitions } from './catalogCapabilitiesData';
import { discoveryCatalogOutcomeDefinitions } from './catalogCapabilitiesDiscovery';
import { socialCatalogOutcomeDefinitions } from './catalogCapabilitiesSocial';
import type { CatalogOutcomeDefinitionMap } from './catalogCapabilities.types';

const catalogOutcomeDefinitions: CatalogOutcomeDefinitionMap = {
  ...commerceCatalogOutcomeDefinitions,
  ...dataCatalogOutcomeDefinitions,
  ...discoveryCatalogOutcomeDefinitions,
  ...socialCatalogOutcomeDefinitions,
};

const fallbackOutcome = (
  platformName: string,
  sortedSkus: readonly DiscoveryApi[],
): CatalogOutcome => ({
  title: `Access ${platformName} data`,
  examples: sortedSkus.find((sku) => sku.description.trim().length > 0)?.description.trim()
    ?? `Explore available ${platformName} endpoints`,
});

export const resolveCatalogOutcomes = (
  platformKey: string,
  platformName: string,
  skus: DiscoveryApi[],
): CatalogOutcome[] => {
  const sortedSkus = [...skus].sort((a, b) => a.slug.localeCompare(b.slug));
  const definitions = catalogOutcomeDefinitions[platformKey];
  if (!definitions) return [fallbackOutcome(platformName, sortedSkus)];

  const liveSkus = new Set(sortedSkus.map((sku) => sku.slug));
  const outcomes = definitions
    .filter((outcome) => outcome.supportingSkus.some((sku) => liveSkus.has(sku)))
    .slice(0, 3)
    .map(({ title, examples }) => ({ title, examples }));
  return outcomes.length > 0 ? outcomes : [fallbackOutcome(platformName, sortedSkus)];
};
